import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-5 mt-4 bg-white border rounded-lg" }

import { PropType } from 'vue';
import { FormSection } from '@/models';
import SummaryNavItem from './SummaryNavItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryNav',
  props: {
  items: {
    type: Array as PropType<Array<FormSection>>,
    default: () => []
  },
  modelValue: {
    type: String,
    default: ''
  }
},
  emits: ["update:modelValue"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createBlock(SummaryNavItem, {
        key: item.id,
        active: __props.modelValue === item.id,
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', item.id))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item.name), 1)
        ]),
        _: 2
      }, 1032, ["active", "onClick"]))
    }), 128))
  ]))
}
}

})